import React from "react";
import { GenericForm } from "./GenericForm";

export function Manager() {
  return <GenericForm type="manager" />;
}
